<div class="row align-items-center search-data-plugin-container">
  <!-- Left side: image -->
  <div class="col-md-2 d-none d-none d-md-block">
  </div>

  <!-- Right side: Text content-->
  <div class="col col-md-10 search-data-plugin-right-col">
    <!-- Title -->
    <div class="search-data-plugin-title">
      <a href="{{searchResultEntry.uri}}" class="search-data-plugin-title-url" [appResultClickTracking]="searchResultEntry">
        <span [innerHTML]="searchResultEntry.title"></span>
      </a>
    </div>

    <!-- Teaser -->
    <p class="search-data-plugin-teaser" [innerHTML]="searchResultEntry.teaser"></p>

    <!-- Dispaly URL -->
    <div class="search-data-plugin-display-url-div">
      <a href="{{searchResultEntry.uri}}" class="search-data-plugin-display-url" [appResultClickTracking]="searchResultEntry">
        {{searchResultEntry.uri}}
      </a>
    </div>

    <div class="row align-items-end">
      <!-- Extra Fields-->
      <div class="col col-sm-8">
        <div class="search-data-plugin-extra-fields" *ngIf="searchResultEntry.extraFields">
          <div *ngFor="let item of searchResultEntry.extraFields | keyvalue">
            <span class="search-data-plugin-extra-field">
              <span class="search-data-plugin-extra-field-key">{{item.key}}:</span>
              {{item.value}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
